export const OFFER_OPTION_DEFAULT = 'OFFER_OPTION_DEFAULT';
export const OFFER_OPTION_EXTRA = 'OFFER_OPTION_EXTRA';
export const OFFER_OPTION_MAX = 'OFFER_OPTION_MAX';

export const DEFAULT_MONTHLY_PAYMENT_DAY = 20;
